import { IBookFromPreviousOrder, IBookStrategy } from '@aca-new/app/pages/book/shared/models/interfaces/book-strategy.interface';
import { EPostMessageType } from '@aca-new/app/shared/models/enums/post-message-type.enum';
import { AcaMessageService } from '@aca-new/app/shared/services/post-message-services/aca-message/aca-message.service';
import { Injectable, Injector } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class LabTestingBookStrategyService implements IBookStrategy {
  public constructor(private readonly _injector: Injector) {}

  public getBookFromPreviousUrl(_orderId: string, _serviceType: string): string {
    return '';
  }

  public bookFromPreviousOrder(data: IBookFromPreviousOrder): void {
    const acaMessageService = this._injector.get(AcaMessageService);
    const postBookMessage = (): void => {
      acaMessageService
        .getWhenAcaReady$()
        .pipe(take(1), untilDestroyed(this))
        .subscribe((): void => {
          acaMessageService.postMessageToAca({
            type: EPostMessageType.BOOK_FROM_PREVIOUS_ORDER,
            data: {
              value: data.previousOrder.originData,
              serviceType: data.previousOrder.originData.serviceTypeText,
            },
          });
        });
    };

    // On an ACA book route the "view more" dialog is closed here (ACA will show the
    // save/discard confirmation). Wait for the dialog to be fully closed before posting
    // the message so the dialog and the ACA confirmation modal never overlap.
    if (data.isAcaBookRoute && data.dialogRef) {
      data.dialogRef
        .afterClosed$()
        .pipe(take(1), untilDestroyed(this))
        .subscribe((): void => {
          postBookMessage();
        });
      data.dialogRef.close();

      return;
    }

    postBookMessage();
  }
}
